<template>
    <div class="container" id="payment-content" :style="{backgroundColor: Theme['gray-100']}">
        <div class="content">
            <div id="payment-content1">
                <div class="d-flex justify-content-between mb-8">
                    <div class="text-start pe-5">
                        <h5>{{ company?.society?.name?.toUpperCase() }}</h5>
                        <p>{{ company?.society?.address }} , {{ company?.society?.city }}, {{ company?.country?.name }}
                            <br>{{ company?.society?.society_email }}
                            <br>{{ company?.society?.society_phone }} 
                            <br>N° IFU {{ company?.society?.ifu_number }} 
                            <br>N° RCCM {{ company?.society?.rccm_number }}
                        </p>
                        <h4>{{ advance ? ($t('payment.advance_invoice') + ' : ' + payment?.invoice?.invoice_number) : ($t('payment.title.payment') + ' : ' + payment?.payment_number) }}</h4>
                        <p class="otherStyle mt-3">{{ $t('invoices.date_creation') + ' : ' + (advance ? formatDate(new Date(payment?.invoice?.invoice_date)) : formatDate(new Date(payment?.payment_date))) }}</p>
                    </div>
                    <div class="text-end" style="text-align: right;">
                        <div class="py-10 mb-5" v-if="company?.society?.logo_url">
                            <img :src="company?.society?.logo_url" alt="Logo" style="width: 100px; height: auto;">
                        </div>
                        <p>{{$t('invoices.to')}}
                            <br><span class="fw-bolder">{{ payment?.invoice?.contact?.fullname }}</span>
                            <br>{{ contactPhone }}
                            <br>{{ payment?.invoice?.contact?.email }}
                        </p>
                    </div>
                </div>
                <div v-if="!advance" style="min-height: 500px;">
                    <div class="d-flex justify-content-between mb-3">
                        <div class="flex-item py-5 flex-column" style="background-color: var(--bs-primary); color: #fff;">
                            <div class="d-flex justify-content-center">
                                <div class="text-start ps-3">
                                    {{ $t('payment.recu') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between otherStyle">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('payment.pay_date') }}
                                </div>
                                <div class="text-start pe-6">
                                   {{ formatDate(new Date(payment?.payment_date)) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between py-3 otherStyle">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('payment.payment_number') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{payment?.payment_number}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between py-3 otherStyle">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('payment.invoice_number') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{payment?.invoice?.invoice_number}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between py-3 otherStyle">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('payment.pay_mode') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{payment?.paymentType?.name}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-3">
                        <div class="flex-item py-5 flex-column">
                            <div class="d-flex justify-content-between">
                            
                            </div>
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: var(--bs-primary); color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.amount') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(payment?.amount))  }} {{ payment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="advance" style="min-height: 400px;">
                    <div class="table-responsive">
                        <table class="table text-center mb-5">
                            <thead>
                                <tr>
                                    <th>N°</th>
                                    <th>{{$t('invoices.description')}}</th>
                                    <th>{{$t('invoices.qty')}}</th>
                                    <th>{{$t('invoices.price')}}</th>
                                    <th>{{$t('invoices.rem')}}</th>
                                    <th>{{$t('invoices.taxes')}}</th>
                                    <th>{{$t('invoices.amount')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <Item v-for="(item, index) in payment?.invoice?.items" :key="index" :item="item" :index="index" :currency="payment?.invoice?.currency?.symbol"/>
                            </tbody>
                        </table>
                    </div>
                    
                    <div class="d-flex justify-content-between otherStyle">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalTax') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(payment?.invoice.invoice_total_tax))  }} {{ payment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.subtotal') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(payment?.invoice.sub_total))  }} {{ payment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between py-3 otherStyle">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalRem') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(payment?.invoice.invoice_discount_value))  }} {{ payment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalTtc') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(payment?.invoice.total))  }} {{ payment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div class="flex-item py-5 otherStyle flex-column" >
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: var(--bs-primary); color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.total') }}
                                </div>
                                <div class="text-start pe-6">
                                {{ $formatLocalAmount(parseFloat(payment?.invoice.total))  }} {{ payment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-10">
                        <div class="flex-item py-5 otherStyle flex-column" >
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: var(--bs-primary); color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.remainAmount') }}
                                </div>
                                <div class="text-start pe-6">
                                {{ $formatLocalAmount(parseFloat(payment?.remaining_payment || 0))  }} {{ payment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <table class="table text-center mb-5">
                        <thead>
                            <tr>
                                <th>N°</th>
                                <th class="text-start">{{$t('payment.advance')}}</th>
                                <th class="text-end pe-6">{{$t('invoices.amount')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>01</td>
                                <td class="text-start">{{$t('crm.payments.advance_ref', { number: payment.payment_number, percentage: payment.percentage })}}%</td>
                                <td class="text-end pe-6">{{ $formatLocalAmount(parseFloat(payment?.amount))  }} {{ payment?.invoice?.currency?.symbol }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div id="payment-content2">
                <div class="d-flex justify-content-between mt-10" v-if="payment?.invoice?.paymentCondition && advance">
                    <div class="text-start">
                        <h4 style="color: #F07817;">{{ $t('invoices.terms') }}</h4>
                        <div>
                            <span v-if="payment?.invoice?.paymentCondition?.name" style="font-weight: 500;">{{$t('crm.estimate.label.paymentCondition')}} : {{ payment?.invoice?.paymentCondition?.name }}</span>
                            <br><span v-if="payment?.invoice?.paymentType?.name" style="font-weight: 500;"> {{$t('crm.estimate.label.paymentType')}} : {{ payment?.invoice?.paymentType?.name }} </span>             
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-5 mb-2" id="payment-content3" :style="{borderTop: '1px solid '+Theme['gray-300']}">
            <div class="d-flex text-start mb-3">
                <span class="fw-bold me-2" v-if="company?.society?.headquarters_address">{{ $t('company.label.headquarters_address') }}: {{ company?.society?.headquarters_address }} / </span>
                <span class="fw-bold" v-if="company?.society?.address">{{ company?.society?.address }}</span>
                <span class="fw-bold me-1" v-if="company?.society?.city">, {{ company?.society?.city }} </span>
                <span class="fw-bold" v-if="company?.country?.name"> {{ company?.country?.name }}</span>
                <span class="fw-bold" v-if="company?.website"> / {{ company?.website }}</span>
            </div>
            <div class="d-flex text-start">
                <span v-if="company?.bankData?.bank_name" class="fw-bold me-2">{{ company?.bankData?.bank_name }} </span>
                <span v-if="company?.bankData?.bic" class="fw-bold me-2">{{ $t('bank.label.bic')?.toUpperCase() }}: {{ company?.bankData?.bic }} </span>
                <span v-if="company?.bankData?.rib" class="fw-bold me-2">{{ $t('bank.label.rib')?.toUpperCase() }}: {{ company?.bankData?.rib }} </span>
                <span v-if="company?.bankData?.iban" class="fw-bold">{{ $t('bank.label.iban')?.toUpperCase() }}: {{ company?.bankData?.iban }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { Theme } from "@/composables/theming";
    import {computed, defineProps} from 'vue'
    import {useStore} from "vuex";
    import {formatDate, $formatLocalAmount} from "@/mixins/Helpers";
    import Item from "./Item";

    const props = defineProps({
        advance: {type: Boolean, default: false},
        payment: { type: Object, required: true }
    })
    const store = useStore()

    const company = computed(() => store.getters['company/getCompanyInfos'])

    const contactPhone = computed(() => {
        if(props.payment?.invoice?.contact) {
            const phones = props.payment?.invoice?.contact?.phone
            if(phones.length)
            return phones[0]
            return ""
        }
        return ""
    })
</script>

<style scoped>
  .container {
    width: 100%;
    max-width: 800px;
    margin: 20px auto;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
  }
  .table th {
    background-color: var(--bs-primary);
    color: #ffffff;
  }
  .table tr {
    background-color: #fff;
    margin-bottom: 5px;
    border-bottom: 3px solid #F2F3F4;
  }
  .otherStyle{
      font-weight: 500;
  }
  .img_class{
      border: 2px dashed var(--bs-primary);
  }
  .flex-item {
       flex: 1;
   }
   .spacer {
       min-width: 20px;
   }
</style>